module.exports = __webpack_public_path__ + "static/media/main-salary.cb1cd945.svg";